var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var downloadReducer = function (state, action) {
    switch (action.type) {
        case 'ADD_TO_QUEUE_SINGLE': {
            var thisItm = action.item;
            thisItm.queueId = crypto.randomUUID().toString();
            return __spreadArray(__spreadArray([], state, true), [thisItm], false);
        }
        case 'SET_ACTIVITY_STATE': {
            return state.map(function (itm) {
                return itm.queueId === action.queueId
                    ? __assign(__assign({}, itm), { activityState: action.activityState }) : itm;
            });
        }
        case 'CLEAR_COMPLETED': {
            return state.filter(function (itm) { return itm.activityState !== 'complete'; });
        }
        default: {
            throw Error("DownloadReducer: Unhandled action type ".concat(action.type));
        }
    }
};
export default downloadReducer;
